<template>
	<div class="page badge_page">
		<div class="rightTba_box">
			<div class="itemobj" @click="navigato('/monthwork')">
				<img class="img100" src="../assets/badge/ys2.png" />
			</div>
			<div class="itemobj" @click="navigato('/badgeRank')">
				<img class="img100" src="../assets/badge/phb2.png" />
			</div>
		</div>
		<div class="bannerbox">
			<el-carousel indicator-position="none">
				<el-carousel-item v-for="(item,index) in bannerList" :key="index">
					<div class="imgbox">
						<!-- :poster="item.imageUrl" -->
						<img class="img100" :src="item.imageUrl" />
						<!-- <img class="img100" src="../assets/badge/15.png"/> -->
					</div>
					<div class="subtitle fontsize36">
						{{item.subtitle}}
					</div>
				</el-carousel-item>
			</el-carousel>
			<div class="timer_open_box">
				<!-- <div class="counttime">
					<img class="bg1" src="../assets/badge/Frame3465816.png" />
					<div class="timeobj">
						<div class="text1 fontsize32">{{timeList[0]}}</div>
						<div class="text2 fontsize14">天</div>
					</div>
					<div class="timeobj">
						<div class="text1 fontsize32">{{timeList[1]}}</div>
						<div class="text2 fontsize14">时</div>
					</div>
					<div class="timeobj">
						<div class="text1 fontsize32">{{timeList[2]}}</div>
						<div class="text2 fontsize14">分</div>
					</div>
					<div class="timeobj">
						<div class="text1 fontsize32">{{timeList[3]}}</div>
						<div class="text2 fontsize14">秒</div>
					</div>
				</div> -->
				<!-- <div class="counttime1">
					<div class="timeobj">
						<div class="text1 fontsize60">{{timeList[0]}}</div>
					</div>
					<div class="timeobj2">
						<div class="text1 fontsize60">:</div>
					</div>
					<div class="timeobj">
						<div class="text1 fontsize60">{{timeList[1]}}</div>
					</div>
					<div class="timeobj2">
						<div class="text1 fontsize60">:</div>
					</div>
					<div class="timeobj">
						<div class="text1 fontsize60">{{timeList[2]}}</div>
					</div>
					<div class="timeobj2">
						<div class="text1 fontsize60">:</div>
					</div>
					<div class="timeobj">
						<div class="text1 fontsize60">{{timeList[3]}}</div>
					</div>
				</div> -->
			</div>
			<div class="timer_open_box">
				<div class="counttime2" v-if="ifshowendtime">
					<!-- 示例：结束时间为当前时间 + 1天2小时3分4秒 -->
					<FlipCountdown :endTime="endTime" />
				</div>
			</div>
		</div>
		<div class="badge_conbox">
			<div class="topbox w1200">
				<div class="itemobj">
					<img class="img100" src="../assets/badge/10.png" />
				</div>
				<div class="itemobj">
					<img class="img100" src="../assets/badge/11.png" />
				</div>
				<div class="itemobj">
					<img class="img100" src="../assets/badge/12.png" />
				</div>
				<div class="itemobj">
					<img class="img100" src="../assets/badge/13.png" />
				</div>
				<div class="itemobj">
					<img class="img100" src="../assets/badge/14.png" />
				</div>
			</div>
			<div class="badgedesc w1200 fontsize16">
				<p>
					在广袤无垠的赛博NOI世界中，跟随我们踏上一段充满着挑战与荣耀的天梯之路。从青铜小白的入门基础试炼，白银进阶智慧启蒙、黄金等级的语法提高荣耀加幂，直到星耀等级的算法入门觉醒，开启异世界新征程。
				</p>
				<p>
					每一个等级不仅象征着冒险者的实力和坚韧不拔的精神，更承载着学习、训练与进阶！每一位冒险者的成长之路都充满智慧与励志之光！
				</p>
			</div>
			<div class="topbox2 w1200">
				<div class="itemobj" @click="navigato('/monthwork')">
					<img class="img100" src="../assets/badge/Frame3465767.png" />
				</div>
				<div class="itemobj" @click="navigato('/badgeRank')">
					<img class="img100" src="../assets/badge/Frame3465768.png" />
				</div>
			</div>
			<div class="cenbox1 w1200">
				<div class="itemobj" v-for="(item,index) in badgeList" :key="index">
					<div class="conbox1" v-if="index%2===0">
						<div class="letfbox">
							<div class="iconbox">
								<img class="img100" :src="item.imgUrl2" />
							</div>
							<div class="desc fontsize14">
								{{item.honorBody}}
							</div>
						</div>
						<div class="imgbox"><img class="img100" :src="item.imgUrl" /></div>
					</div>
					<div class="conbox1 conbox2" v-else>
						<div class="imgbox"><img class="img100" :src="item.imgUrl" /></div>
						<div class="letfbox">
							<div class="iconbox">
								<img class="img100" :src="item.imgUrl2" />
							</div>
							<div class="desc fontsize14">
								{{item.honorBody}}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="block58"></div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex'
	import FlipCountdown from './FlipCountdown.vue'
	export default {
		components:{
			FlipCountdown
		},
		data() {
			return {
				bannerList: [0],
				badgeList: [], //荣耀
				timeList: ['00', '00', '00', '00'],
				timer: null,
				isExpired: 0,
				ifmonthwork:false,//是否有月赛
				ifshowendtime:false,//是否开始倒计时
				endTime: null,
			};
		},
		mounted: function() {
			//初始化
			this.initPage()
		},
		computed: {
			...mapState(['userInfo', 'isLogin', 'sysRole']),
		},
		beforeDestroy() {
			// 组件销毁前清除定时器
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			...mapMutations(["SET_USERINFO", 'SET_ISLOGIN']),
			//初始化
			async initPage() {
				//轮播图和广告
				await this.getwheelPage(5)
				//获取荣誉等
				this.gethonorList()
				//获取月赛第一个详情
				this.getgroupDetail()
			},
			//获取月赛第一个详情
			getgroupDetail() {
				var _this = this
				var params = {
					currentPage: 1,
					pageSize: 1
				}
				this.$http.post('app/hlexam/hlMonthQuestExam/index', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						if (res.data.records && res.data.records.length > 0) {
							_this.endTime = _this.$util.getDateTime2(res.data.records[0].examStartTime)
							_this.ifshowendtime = true
							const now = Date.now();
							if (now >= _this.endTime) {
								_this.ifmonthwork = true
							}
							//启动定时器
							//_this.startCountdown()
							// res.data.records.forEach((item, index) => {
							// 	const examStartTime = _this.$util.getDateTime2(item.examStartTime)
							// 	const examEndTime = _this.$util.getDateTime2(item.examEndTime)
							// });
						}else{
							_this.ifmonthwork = false
						}
					}
				})
			},
			//启动定时器
			startCountdown() {
				// 清除现有定时器
				if (this.timer) {
					clearInterval(this.timer);
				}
				// 立即更新一次
				this.updateCountdown();
				// 设置定时器每秒更新
				this.timer = setInterval(() => {
					this.updateCountdown();
				}, 1000);
			},
			updateCountdown() {
				if (!this.endTime) return;
				const now = new Date();
				const diff = this.endTime - now;
				if (diff <= 0) {
					// 时间已过，设置全部为00
					this.timeList = ['00', '00', '00', '00'];
					this.isExpired = 2;
					clearInterval(this.timer);
					return;
				}
				this.isExpired = 1;
				// 计算天、时、分、秒
				const days = Math.floor(diff / (1000 * 60 * 60 * 24));
				const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((diff % (1000 * 60)) / 1000);

				// 更新timerList数组，确保两位数显示
				this.timeList = [
					days.toString().padStart(2, '0'),
					hours.toString().padStart(2, '0'),
					minutes.toString().padStart(2, '0'),
					seconds.toString().padStart(2, '0')
				];
			},
			//获取荣誉等
			gethonorList() {
				var _this = this
				var params = {}
				params["currentPage"] = 1
				params["pageSize"] = 18
				this.$http.post('app/hlexam/lcUserPoint/honorList', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.badgeList = res.data
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//获取轮播图
			getwheelPage(type) {
				var _this = this
				return new Promise((resolve, reject) => {
					var params = {}
					params["currentPage"] = 1
					params["pageSize"] = 18
					params["type"] = type
					this.$http.post('app/wheel-advert/getPage', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							var records = res.data.records
							// imageUrl:require("../assets/static/banner1.png")
							if (records.length > 0) {
								_this.bannerList = records
							}
							resolve(true)
						} else {
							reject(false)
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				})
			},
			//跳转
			navigato(url, query) {
				if(url=="/monthwork"){
					if(this.ifmonthwork){
						this.$util.routerPath(url, query)
					}else{
						this.$confirm("月赛暂未开启 敬请期待！", '温馨提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				}else{
					this.$util.routerPath(url, query)
				}
			},

		}
	};
</script>
<style lang="scss" scoped>
	.hoverbig:hover {
		transform: scale(1.05);
		transition: ease all 0.3s;
	}
</style>